import { EmployeeDatabase, InfiniteScroll, StopWatch, TrafficLight } from "./assets";

export const PROJECTS = [
  {
    id: 1,
    name: "Infinite Scroll",
    description:
      "Developed an infinite scroll feature in a React application, optimizing user experience by dynamically loading content as the user scrolls.",
    link: "/infinite-scroll",
    image: InfiniteScroll,
  },
  {
    id: 2,
    name: "Traffic Light",
    description:
      "Developed a traffic light simulation using React, featuring real-time state management for seamless transitions between red, yellow, and green lights.",
    link: "/traffic-light",
    image: TrafficLight,
  },
  {
    id: 3,
    name: "StopWatch",
    description:
      "A React Stopwatch that tracks time in hours, minutes, and seconds, allowing users to start, stop, and reset the timer.",
    link: "/stopwatch",
    image: StopWatch,
  },
  {
    id: 4,
    name: "Job Board",
    description:
      "A React Stopwatch that tracks time in hours, minutes, and seconds, allowing users to start, stop, and reset the timer.",
    link: "/jobBoard",
    image: StopWatch,
  },
  {
    id: 5,
    name: "Employee Database",
    description:
      "A React Stopwatch that tracks time in hours, minutes, and seconds, allowing users to start, stop, and reset the timer.",
    link: "/employeeDatabase",
    image: EmployeeDatabase,
  },
];
